import CourseViewerHeader from './CourseViewerHeader';
import SkillViewerHeader from './SkillViewerHeader';
import TrackViewerHeader from './TrackViewerHeader';
export default {
    Course: CourseViewerHeader,
    Skill: SkillViewerHeader,
    Track: TrackViewerHeader
};
//# sourceMappingURL=index.js.map